import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoanProductMatchDialogComponent } from './loan-product-match-dialog/loan-product-match-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { LoanProductMatchFilteringSmartComponent } from './loan-product-match-filtering-smart/loan-product-match-filtering-smart.component';
import { LoanProductMatchSortingSmartComponent } from './loan-product-match-sorting-smart/loan-product-match-sorting-smart.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { LoanProductMatchFilteringComponent } from './loan-product-match-filtering/loan-product-match-filtering.component';


@NgModule({
  declarations: [
    LoanProductMatchDialogComponent,
    LoanProductMatchFilteringSmartComponent,
    LoanProductMatchSortingSmartComponent,
    LoanProductMatchFilteringComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatCheckboxModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatTooltipModule,
    MatTabsModule,
    MatListModule
  ],
  exports: [
    LoanProductMatchDialogComponent,
  ],
})
export class LoanProductMatchModule { }
